import { render, staticRenderFns } from "./PayGrade.vue?vue&type=template&id=635afb24&scoped=true"
import script from "./PayGrade.vue?vue&type=script&lang=js"
export * from "./PayGrade.vue?vue&type=script&lang=js"
import style0 from "./PayGrade.vue?vue&type=style&index=0&id=635afb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635afb24",
  null
  
)

export default component.exports